<template>
    <div class="form-group">
        <label :for="name"
               class="col-sm-12 control-label">{{ label }}</label>
        <div class="col-sm-12">
            <span v-if="note">{{ note }}</span>
            <multiselect :id="name"
                         v-model="form[name]"
                         :options="options"
                         :multiple="multiple"
                         :close-on-select="true"
                         :clear-on-select="false"
                         :preserve-search="true"
                         :placeholder="$t('multiselect_placeholder')"
                         :label="valueLabel"
                         :track-by="trackBy"
                         :preselect-first="false"
                         :class="{ 'is-invalid': form.errors.has(name) }"
                         :max="max">
            </multiselect>
            <has-error :form="form" :field="name"></has-error>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {HasError} from "vform/src/components/bootstrap4";

export default {
    name: "MultiSelectInput",
    components: {Multiselect, HasError},
    props: {
        label: String,
        form: Object,
        name: String,
        options: Array,
        valueLabel: {
            type: String, default: 'name'
        },
        trackBy: {
            type: String, default: 'id'
        },
        multiple: {type: Boolean, default: true},
        note: {type: String, default: null},
        max: {type: Number, default: null}
    }
}
</script>

<style scoped>

</style>
